// Must stay in sync with WIDTHS in scripts/convert-images.mjs.
const WIDTHS = [640, 1024, 1536];

function avifSrcSet(src, intrinsicWidth) {
  const base = src.replace(/\.jpe?g$/i, '');
  const parts = WIDTHS.filter(w => w < intrinsicWidth).map(w => `${base}-${w}.avif ${w}w`);
  parts.push(`${base}.avif ${intrinsicWidth}w`);
  return parts.join(', ');
}

export default function PictureImg({ src, alt = '', width, height, sizes = '100vw', className, loading = 'lazy', fetchPriority, ...rest }) {
  const srcSet = width ? avifSrcSet(src, width) : src.replace(/\.jpe?g$/i, '.avif');
  return (
    <picture>
      <source srcSet={srcSet} sizes={sizes} type="image/avif" />
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        {...rest}
      />
    </picture>
  );
}
